var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.loading === true)?_c('div',{staticClass:"modal"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }